import { render, staticRenderFns } from "./RemoteProgramas.vue?vue&type=template&id=3f3c189c&"
import script from "./RemoteProgramas.vue?vue&type=script&lang=js&"
export * from "./RemoteProgramas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports